import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
import { useWidget } from '@/logics/chart';
import { onMounted, watch } from 'vue';
import { widget } from '../../../public/charting_library';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    props: {
        height: { default: 316 },
        locale: null,
        pair: null,
        containerId: null
    },
    setup(__props) {
        const props = __props;
        const libraryPath = 'charting_library/';
        const { getWidgetOptions, getWidgetOverrides } = useWidget();
        const store = useStore();
        let focrexWidget;
        const settingWidget = () => {
            const container = document.getElementById(props.containerId);
            if (!!container) {
                const widgetOptions = getWidgetOptions(props.pair, props.containerId, libraryPath);
                focrexWidget = new widget(widgetOptions);
                focrexWidget.onChartReady(() => {
                    focrexWidget.applyOverrides(widgetOptions.overrides);
                });
            }
        };
        onMounted(settingWidget);
        watch(() => store.state.theme, (value) => __awaiter(this, void 0, void 0, function* () {
            yield focrexWidget.changeTheme('Dark' === value ? 'dark' : 'light');
            yield focrexWidget.applyOverrides(getWidgetOverrides(value));
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", { id: __props.containerId }, null, 8, _hoisted_1));
        };
    }
});
